
import { Options, prop, Vue } from "vue-class-component";
import { SearchSttScanApiRequest } from "@/data/payload/api/CariSttApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import { LOCATION_AREA } from "../misc";
import { SearchSttScan } from "@/domain/entities/ListCariSTT";
import { ListCariSTTController } from "@/app/ui/controllers/ListCariSTTController";
import { removeNewLineWhitespace } from "@/app/infrastructures/misc/Utils";
import ModalAreaScan from "./ModalAreaScan.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  latestSttData = prop<SearchSttScan>({
    required: true,
    default: new SearchSttScan()
  });
}

@Options({
  emits: ["success", "error"],
  components: {
    ModalAreaScan
  }
})
class SearchSttScanComponent extends Vue.with(Props) {
  locationArea = LOCATION_AREA;
  activeLocationArea(key: string) {
    return this.form.scanLocation === key;
  }

  form = new SearchSttScanApiRequest();
  cacheForm = new SearchSttScanApiRequest();
  sttNotFound = false;
  sttAlreadyScan = false;
  openConfirmArea = !this.isPosAccount;

  onConfirmAreaPopup(data: {
    locationArea: string;
    radioLocationArea: string;
  }) {
    this.form = new SearchSttScanApiRequest({
      scanLocation: data.radioLocationArea,
      scanLocationNote: data.locationArea
    });
  }

  get isValidScan() {
    if (this.isPosAccount) {
      this.form.scanLocation = "POS";
    }
    return (
      this.form.sttNo &&
      this.form.scanLocation &&
      (this.form.scanLocation !== "OTHERS" || this.form.scanLocationNote)
    );
  }

  async onScan() {
    if (!this.isValidScan) return;

    try {
      this.sttNotFound = false;
      this.sttAlreadyScan = false;
      MainAppController.showLoading();
      const res = await ListCariSTTController.searchSttScan(this.form);
      playNotification("success");

      this.$emit("success", res);

      this.form = new SearchSttScanApiRequest({
        scanLocation: this.form.scanLocation,
        scanLocationNote: this.form.scanLocationNote
      });
      this.cacheForm = new SearchSttScanApiRequest();
    } catch (error) {
      playNotification("error");
      this.$emit("error", error);
      if (error.response.data.message.id === "STT sudah discan") {
        this.sttAlreadyScan = true;
      } else {
        this.sttNotFound = true;
      }
      this.cacheForm = new SearchSttScanApiRequest(this.form);
    } finally {
      MainAppController.closeLoading();
    }
  }
  get isHanging() {
    return this.latestSttData.status.toLowerCase() === "hanging";
  }

  replaceNewLine(value: string) {
    const removedNewLineAddress = removeNewLineWhitespace(value, " ");
    this.form.scanLocationNote = removedNewLineAddress;
    return removedNewLineAddress;
  }

  onCloseModal() {
    const inputStt: any = this.$refs.inputStt;
    inputStt.focus();
  }

  get isPosAccount() {
    return AccountController.accountData.isPosAccount;
  }

  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign;
  }
}
export default SearchSttScanComponent;
